module.exports = __webpack_public_path__ + "static/img/ic_home_fw_map@2x.05e7595e.png";